import type { ContentProps } from '@workspace/core-ts/types';

export default {
    descriptionEmail: {
        site: 'En nous communiquant votre adresse e-mail, vous acceptez que la gestion et l’exécution de votre contrat soient réalisées par voie dématérialisée : vous pouvez y mettre un terme à tout moment et sans frais en vous rendant sur votre espace client.',
        courtier:
            'En nous communiquant son adresse e-mail, il accepte que la gestion et l’exécution de son contrat soient réalisées par voie dématérialisée : il peut y mettre un terme à tout moment et sans frais en se rendant sur son Espace Assuré.',
    },
} as unknown as ContentProps;
